export const API_BASE = process.env.REACT_APP_API_BASE
  || process.env.REACT_APP_API_BASE_URL
  || 'https://igmportariaremota.com.br:3838';

export const buildApiUrl = (path) => {
  if (!path) return API_BASE;
  return path.startsWith('/') ? `${API_BASE}${path}` : `${API_BASE}/${path}`;
};

export const resolveMediaUrl = (arquivo) => {
  if (!arquivo) return '';
  return `${API_BASE}/Media/${arquivo}`;
};
